import { render, staticRenderFns } from "./moreTWTN.vue?vue&type=template&id=06858047&lang=pug&"
import script from "./moreTWTN.vue?vue&type=script&lang=js&"
export * from "./moreTWTN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports